import { useState, useEffect } from 'react';
import { Button, Form, Modal } from 'react-bootstrap'; // Ensure Modal import
import { renderErrorToast } from '../../utility/helpers';

const EditTier = ({ show, onClose, onSave, selectedTier }: any) => {
    const [formValues, setFormValues] = useState(selectedTier);

    // Update form values when selectedTier changes
    useEffect(() => {
        setFormValues(selectedTier);
    }, [selectedTier]);
    const [errors, setErrors] = useState({
        name: '',
        downloadsLimit: '',
        profileViewsLimit: '',
        jobCreatesLimit: ''
    });

    // Handle input changes
    const handleInputChange = (e: any) => {
        const { name, value, type, checked } = e.target;
        setFormValues((prevValues: any) => ({
            ...prevValues,
            [name]: type === 'checkbox' ? checked : value,
        }));

        // Clear error when user starts typing
        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: '',
        }));
    };

    // Validate fields before saving
    const validateFields = () => {
        const newErrors = {
            name: formValues.name.trim()
                ? ''
                : 'You missed this.',
            downloadsLimit: formValues.downloadsLimit.trim()
                ? ''
                : 'You missed this.',
            profileViewsLimit: formValues.profileViewsLimit.trim()
                ? ''
                : 'You missed this.',
            jobCreatesLimit: formValues.jobCreatesLimit.trim()
                ? ''
                : 'You missed this.',
        };
        setErrors(newErrors);
        if (Number(formValues.downloadsLimit) < 0) {
            renderErrorToast('Number of downloads must be 0 or greater.'); // Display toast message
            return false; // Prevent further validation as toast is shown
        }
        if (Number(formValues.profileViewsLimit) < 0) {
            renderErrorToast('Number of profile`s view must be 0 or greater.'); // Display toast message
            return false; // Prevent further validation as toast is shown
        }
        if (Number(formValues.jobCreatesLimit) < 0) {
            renderErrorToast('Number of jobs create must be 0 or greater.'); // Display toast message
            return false; // Prevent further validation as toast is shown
        }

        // Return true if no errors
        return !newErrors.name && !newErrors.downloadsLimit && !newErrors.profileViewsLimit && !newErrors.jobCreatesLimit;
    };

    // Save the changes
    const handleSaveChanges = () => {
        if (validateFields()) {
            onSave(formValues);
            onClose();
        }
    };
    return (
        <Modal
            show={show}
            onHide={onClose}
            dialogClassName="modal-407 top-right-modal modal-dialog-centered"
            className="confirmation-modal add-tier-modal"
        >
            <Modal.Body>
                <div className="form-wrap">
                    <Form className="full-width-form">
                        <div className="tier-name">
                            <Form.Group className="form-group">
                                <Form.Control
                                    type="text"
                                    name="name"
                                    placeholder="Enter plan name"
                                    value={formValues.name}
                                    onChange={handleInputChange}
                                    isInvalid={!!errors.name}
                                />
                            </Form.Group>
                        </div>
                        <div className="add-tier-footer">
                            <div className="tier-name">
                                <Form.Group className="form-group">
                                    <Form.Control
                                        type="number"
                                        name="downloadsLimit"
                                        placeholder="Number of downloads"
                                        value={formValues.downloadsLimit}
                                        onChange={handleInputChange}
                                        isInvalid={!!errors.downloadsLimit}
                                        min="0"
                                        onKeyDown={(e) =>
                                            e.key === 'e' && e.preventDefault()
                                        }
                                    />
                                </Form.Group>
                            </div>

                            <div className="tier-name">
                                <Form.Group className="form-group">
                                    <Form.Control
                                        type="number"
                                        name="profileViewsLimit"
                                        placeholder="Number of Profile View"
                                        value={formValues.profileViewsLimit}
                                        onChange={handleInputChange}
                                        isInvalid={!!errors.profileViewsLimit}
                                        min="0"
                                        onKeyDown={(e) =>
                                            e.key === 'e' && e.preventDefault()
                                        }
                                    />
                                </Form.Group>
                            </div>

                            <div className="tier-name">
                                <Form.Group className="form-group">
                                    <Form.Control
                                        type="number"
                                        name="jobCreatesLimit"
                                        placeholder="Number of Job Create"
                                        value={formValues.jobCreatesLimit}
                                        onChange={handleInputChange}
                                        isInvalid={!!errors.jobCreatesLimit}
                                        min="0"
                                        onKeyDown={(e) =>
                                            e.key === 'e' && e.preventDefault()
                                        }
                                    />
                                </Form.Group>
                            </div>

                            <div className="tier-name">
                                <div className='mask-control' data-tooltip='Mask candidate personal details until a premium plan is selected.'>
                                    <span className='mask-label'>Mask</span>
                                    <input
                                        id='mask-toggle-edit'
                                        name='mask'
                                        type='checkbox'
                                        className='mask-toggle'
                                        checked={!!formValues.mask}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor='mask-toggle-edit' className='mask-switch' aria-label='toggle mask'></label>
                                </div>
                            </div>

                            <div className="tier-name">
                            <Button
                                className="submit scale"
                                onClick={handleSaveChanges}
                            >
                                Save
                            </Button>
                            </div>
                        </div>
                    </Form>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default EditTier;
